import { render, staticRenderFns } from "./DeviceTypeList.vue?vue&type=template&id=0080fdf8&scoped=true"
import script from "./DeviceTypeList.vue?vue&type=script&lang=js"
export * from "./DeviceTypeList.vue?vue&type=script&lang=js"
import style0 from "./DeviceTypeList.vue?vue&type=style&index=0&id=0080fdf8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_j7knk6mol3vthgvrc443rvn57u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0080fdf8",
  null
  
)

export default component.exports